import { toast } from 'sonner';

const requestTransfer = async (api, companyId) => {
    try {
        await api.post('/company-transfers', { company_id: companyId });
        toast.success('Demande de transfert envoyée au commercial détenteur et au Super Admin');
        window.dispatchEvent(new Event('company-transfers-changed'));
    } catch (error) {
        toast.error(error.response?.data?.detail || 'Erreur lors de la demande de transfert');
    }
};

// Runs a company save; on SIREN conflict, lets a super admin force it or a salesperson request a transfer.
export const saveCompanyWithSirenGuard = async (request, { api, canForce }) => {
    try {
        return await request(false);
    } catch (error) {
        const detail = error.response?.data?.detail;
        if (error.response?.status !== 409 || typeof detail !== 'object') throw error;
        error.response.data.detail = detail.message;
        if (canForce) {
            if (window.confirm(`${detail.message}\n\nEn tant que Super Admin, voulez-vous forcer l'enregistrement ?`)) {
                return await request(true);
            }
        } else if (detail.can_request_transfer) {
            if (window.confirm(`${detail.message}\n\nVoulez-vous demander le transfert de ce client ?`)) {
                await requestTransfer(api, detail.company_id);
            }
            error.handled = true;
        }
        throw error;
    }
};

export const askSiren = (name) => {
    const value = window.prompt(`Numéro SIREN (9 chiffres) ou SIRET (14 chiffres) de « ${name} » :`);
    if (value === null) return null;
    const cleaned = value.replace(/[\s.-]/g, '');
    return /^(\d{9}|\d{14})$/.test(cleaned) ? cleaned : '';
};

export const REGISTRY_FIELDS = ['legal_name', 'trade_name', 'address_line_1', 'postal_code', 'city', 'sector'];

// Returns official registry values for the empty fields of a company form.
export const fillFromRegistry = async (api, siret, allowedSectors) => {
    const { data } = await api.get(`/companies/registry-lookup?siret=${siret}`);
    const pickEmpty = (formData) => {
        const filled = {};
        REGISTRY_FIELDS.forEach((field) => {
            const value = data[field];
            if (!value || formData[field]) return;
            if (field === 'sector' && !allowedSectors.includes(value)) return;
            filled[field] = value;
        });
        return filled;
    };
    return { pickEmpty, isActive: data.is_active };
};
